import { refreshToken, logout } from "../allRequests/refreshTokenOrLogOut";

async function getDataByParam(data) {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URI}${data.path}/${data.param}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: data.accessToken ? `Bearer ${data.accessToken}` : "",
    },
  });
  const result = await response.json();

  // Check if we got a 401 Unauthorized response
  if (response.status === 401 || result?.message?.error === "Unauthorized") {
    // Try to refresh the token
    const refreshSuccess = await refreshToken();

    if (refreshSuccess) {
      // Token refreshed successfully, retry the request with new token
      const userString = localStorage.getItem("currentUser");
      if (!userString) {
        logout();
        return result;
      }
      let user;
      try {
        user = JSON.parse(userString);
      } catch (e) {
        logout();
        return result;
      }

      const retryResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URI}${data.path}/${data.param}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: user.accessToken ? `Bearer ${user.accessToken}` : "",
          },
        }
      );
      const retryResult = await retryResponse.json();

      // Check if retry also failed with 401
      if (retryResponse.status === 401 || retryResult?.message?.error === "Unauthorized") {
        // Second failure, logout and navigate to login
        logout();
        return retryResult;
      }

      return retryResult;
    }

    // Token refresh failed, logout and navigate to login
    logout();
    return result;
  }

  return result;
}

export default getDataByParam;
